<script>
  import { toastState, toast } from '$lib/toast.svelte.js';
  import Toast from './Toast.svelte';
</script>

<div class="fixed right-4 top-4 z-50 flex w-80 max-w-[calc(100vw-2rem)] flex-col gap-2">
  {#each toastState.items as item (item.id)}
    <Toast {...item} onDismiss={toast.dismiss} />
  {/each}
</div>
